import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Devices } from 'src/app/modules/entry-control/interfaces/devices';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';

@Component({
  selector: 'app-add-tags',
  templateUrl: './add-tags.component.html',
  styleUrls: ['./add-tags.component.css']
})
export class AddTagsComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }
  ngOnInit(): void {
    this.getData();
    if (this.data != null) {
      this.primaryForm.patchValue(this.data);
    }
  }
  /**
   * Hago referencia a la ventana actual
   */
  @Input()
  modalRef: NgbModalRef | undefined;

  @Input()
  data: any=null;
  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Devices>();
  
  facilityes:Facility[];


  primaryForm = new UntypedFormGroup({
    code: new UntypedFormControl(),
    tag: new UntypedFormControl(),
    location: new UntypedFormControl(),
    facility_id: new UntypedFormControl(0),
  });

  create() {
    this.api.createTags(this.primaryForm).subscribe(
      (response) => {
        this.toast.success('Tag creado correctamente', 'Gestión Dispositivos');
        this.record.emit(response.data as Devices);
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }

      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error');
      }
    );
  }
  getData() {
    this.api.getAllFacility().subscribe(
      (response) => {
        this.facilityes = response.data as Facility[];
      }
    );
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
